// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2T07X","author":"Table_author__1HyGU","authorImage":"Table_authorImage__3Jppm","unreadRow":"Table_unreadRow__2CK8l"};